export default "__VITE_ASSET__Bap2h702__"